import React, { FC, ReactElement, useEffect, useState } from 'react';
import cns from 'classnames';
import { useSelector } from 'react-redux';
import { getEventKey } from '../../../../stores/reducers/userData';
import { ParamsDto } from '../../../../stores/reducers/sections';
import { initWidget } from '../../../../utils/widget-init';

import './Speakers.sass';
import './SpeakersViews/speakers.views.sass';
interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
  sectionId: string;  
  sectionData?: Array<ParamsDto>;
}

const Speakers: FC<Props> = ({ className, bgSettings, sectionName, sectionId, sectionData }): ReactElement => {
  const eventKey = useSelector(getEventKey);
  const widgetRef = React.useRef<HTMLDivElement | null>(null);

  const getSettingParam = (type: string): string => {
    return sectionData?.find((param) => param.type === type)?.value ?? '';
  };

  React.useEffect(() => {
    initWidget({
      target: widgetRef.current,
      widgetPath: `/widget/${eventKey}/members`,
      widgetId: getSettingParam('widgetId'),
    });
  }, []);

  if (!getSettingParam('widgetId')) {
    return <></>;
  }
  
  return (
    <section
      className={cns(
        'inner-section',
        'speakers-section',
        bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        className
      )}
      style={{ backgroundColor: bgSettings && bgSettings.color }}
    >
      <div className="container" id={sectionId}>
        <div className="section-title">{sectionName}</div>
        <div ref={widgetRef} id="widget-members"></div>
      </div>
    </section>
  );
};

export default Speakers;
